import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { MarkenFilterDto } from '../Mza/Entities/Dtos/markenfilterdto.entity';
//#endregion

@Injectable()
export class MarkenFilterDtoService extends ODataEntityService<MarkenFilterDto> {
  constructor(protected client: ODataClient) {
    super(client, 'MarkenFilterDto', 'Mza.Entities.Dtos.MarkenFilterDto');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  //#endregion
}
